export default __webpack_public_path__ + "static/media/Biion-2-Benjamin-Proulx-Mathers-Christian-Lagueux-YUL-MUSIC-Montreal-Composer.180b86b6.jpg";